import H4 from '@base/H4/H4';
import P1 from '@base/P1/P1';
import styled from '@emotion/styled';
import { Fonts, mediaQuery, Spacings } from '@styles/index';

export const Section = styled.section`
  margin: ${Spacings.SPACING_10B} 0;
`;

export const StyledH4 = styled(H4)`
  margin-top: ${Spacings.SPACING_8B};
  margin-bottom: ${Spacings.SPACING_4B};
`;

export const StyledP1 = styled(P1)`
  height: 100%;

  .bold {
    font-weight: ${Fonts.SEMIBOLD};
  }
`;

export const StyledOl = styled.ol`
  margin: ${Spacings.SPACING_14} 0;
`;

export const StyledLi = styled.li`
  margin-bottom: ${Spacings.SPACING_4B};
  color: var(--color-text-primary);
  list-style: ${(props) => props.$listStyle || 'number'};

  :last-child {
    margin: ${Spacings.SPACING_6B} 0 ${Spacings.SPACING_8B};
  }

  ${mediaQuery.uptoMobile} {
    margin-bottom: ${Spacings.SPACING_6B};
    :last-child {
      margin: ${Spacings.SPACING_12B} 0 ${Spacings.SPACING_18B};
    }
  }
`;

export const InfoWrapper = styled.div`
  display: grid;
  grid-template-columns: ${Spacings.SPACING_6B} auto;

  height: ${Spacings.SPACING_6B};
  transform: translate(0, 6px);

  > p {
    margin-left: ${Spacings.SPACING_4B};
  }
`;

export const ImageWrapper = styled.div`
  margin: 0 ${Spacings.SPACING_2B};
  width: 100%;
`;
